import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { useUserPermissions } from '../../hooks/useUserPermissions';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { policyControllerEditPolicyExternalId } from 'korint-sdk';
import { useMutation } from '@tanstack/react-query';
import { InformationField } from '@folio/components/module-elements/InformationCard/InformationField';
import { useTranslation } from 'react-i18next';

export function EditPolicyExternalIdModule() {
  const { t } = useTranslation();
  const { policy, mutate } = usePolicyOnDashboard();

  const { can } = useUserPermissions({
    productId: policy.productId,
    actions: ['EDIT_POLICY_EXTERNAL_ID'],
  });

  const { mutateAsync: editPolicyExternalId } = useMutation({
    mutationFn: async (externalId: string) =>
      await policyControllerEditPolicyExternalId(policy.id, { externalId }),
    onSuccess: () => mutate(),
  });

  if (!can['EDIT_POLICY_EXTERNAL_ID']) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('editPolicyExternalId.label')}</CardTitle>
      </CardHeader>
      <CardContent>
        <table className="w-full table-fixed">
          <tbody>
            <InformationField
              fieldKey="externalId"
              label={t('editPolicyExternalId.label')}
              updateEntity={async (_, value) => {
                if (typeof value === 'string') {
                  await editPolicyExternalId(value);
                }
              }}
              editionMode="INLINE"
              type="text"
              value={policy.externalId}
            />
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
